/* Skinny Genie: keep the draft-theme preview sticky while clicking around.

   Shopify remembers which theme you are previewing in a cookie and strips
   ?preview_theme_id= back off the URL. When a browser will not keep that
   cookie (private windows, Safari tracking prevention, blocked site data),
   every in-site click silently falls back to the PUBLISHED theme, so the
   draft looks like it "reverted". This re-attaches the parameter to internal
   links and same-origin GET forms so click-through stays on the draft.

   Self-disabling: on the published theme Shopify.theme.role is "main" and
   this does nothing, so it is safe to leave in the theme after go-live. */
(function () {
  var theme = window.Shopify && window.Shopify.theme;
  if (!theme || !theme.id || theme.role === 'main') return;

  var PARAM = 'preview_theme_id';
  var ID = String(theme.id);

  function decorated(href) {
    try {
      var u = new URL(href, location.href);
      if (u.origin !== location.origin) return null;
      if (u.pathname.indexOf('/cdn/') === 0) return null;
      if (u.searchParams.get(PARAM) === ID) return null;
      u.searchParams.set(PARAM, ID);
      return u.href;
    } catch (e) {
      return null;
    }
  }

  function skip(a) {
    var raw = a.getAttribute('href');
    if (!raw || raw.charAt(0) === '#') return true;
    if (/^(mailto:|tel:|javascript:)/i.test(raw)) return true;
    return a.hasAttribute('download');
  }

  function decorate(a) {
    if (skip(a)) return;
    var next = decorated(a.href);
    if (next) a.setAttribute('href', next);
  }

  /* Pass over the links present at load, so hovering, middle-clicking and
     "copy link address" all carry the parameter too. */
  function decorateAll() {
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) decorate(links[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorateAll);
  } else {
    decorateAll();
  }

  /* Catch links added later: mega menu, cart and favourites drawers, search
     results. Rewriting during the capture phase still affects the click. */
  function onClick(e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (a) decorate(a);
  }
  document.addEventListener('click', onClick, true);
  document.addEventListener('auxclick', onClick, true);

  /* Same-origin GET forms (the site search) would otherwise drop it. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    if ((f.getAttribute('method') || 'get').toLowerCase() !== 'get') return;
    try {
      var action = f.getAttribute('action') || location.pathname;
      if (new URL(action, location.href).origin !== location.origin) return;
    } catch (err) {
      return;
    }
    if (f.querySelector('input[name="' + PARAM + '"]')) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = PARAM;
    input.value = ID;
    f.appendChild(input);
  }, true);
})();
